import { defineComponent as _defineComponent } from 'vue'
import {
    getCurrentInstance, inject, onBeforeUnmount, onMounted, onUpdated, ref, shallowRef, unref, watch,
} from 'vue';

import { useGenerateIds } from '../../composables';
import type { IdRef } from './injection';
import { NavTabsParentKey } from './injection';


export default /*#__PURE__*/_defineComponent({
  __name: 'tab-pane',
  props: {
    initiallyActive: { type: Boolean },
    title: null,
    id: null
  },
  emits: ["activated", "deactivated", "toggle"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'activated', value: undefined): void;
    (event: 'deactivated', value: undefined): void;
    (event: 'toggle', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    initiallyActive?: boolean;
    title?: string;
    id?: string;
}


//eslint-disable-next-line no-spaced-func

const active = ref(props.initiallyActive);
const visible = ref<boolean>();
const element = shallowRef<HTMLElement | undefined>();
const vm = getCurrentInstance();
function getIndex() {
    const instance = vm?.proxy;
    let index = instance?.$parent?.$children?.indexOf(instance);
    if((index !== undefined) && (index < 0)) {
        index = instance?.$parent?.$children?.length;
    }
    return index ?? 0;
}

const generateIds = useGenerateIds();
const idRef: IdRef = (() => {
    const id = props.id ?? generateIds();
    return {
        id,
        tabid: `${id}--tab`,
        btnid: `${id}--btn`,
    };
})();
const navTabsParent = inject(NavTabsParentKey);
function isVisible() {
    const _element = unref(element);
    //vue v-show
    return !!(_element && (_element.style.display !== 'none'));
}

watch(active, (val, old) => {
    if(!!val !== !!old) {
        if(val) emit('activated', undefined); else emit('deactivated', undefined);
        emit('toggle', val ?? false);
    }
});
onMounted(() => {
    visible.value = isVisible();
    navTabsParent?.registerPane?.({
        idRef,
        index: getIndex(),
        active,
        props,
        visible,
    });
});
onBeforeUnmount(() => {
    navTabsParent?.unregisterPane?.(idRef);
});
onUpdated(() => {
    visible.value = isVisible();
    navTabsParent?.updatePane?.(idRef, getIndex());
});

return { __sfc: true,props, emit, active, visible, element, vm, getIndex, generateIds, idRef, navTabsParent, isVisible }
}

})